import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Badge,
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomMultiSelect,
  CustomPanel,
  PageHeader,
  Periodo,
  PickingType,
  ThreeDots,
  InputText,
} from '../../../../components'
import Modal from '../ModalPicking'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { selectedPickingChanged } from '../../../../store/actions/picking.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import parsePickingStatus, {
  OCORRENCIA_FILTER_OPTIONS,
  PickingOcorrencia,
  PickingStatus,
} from '../../../../constants/picking-status'
import usePickingCodigoBarra, { LOAD_MESSAGE } from './PickingCodigoBarraHook'
import { FaTrash } from 'react-icons/fa'
import { Fieldset } from 'primereact/fieldset'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'
import { usePickingCodigoBarraContext } from '../../../../contexts/PickingContext'

function PickingCodigoBarra({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = usePickingCodigoBarra()
  const { pickingCodigoBarraContext, setPickingCodigoBarraContext } = usePickingCodigoBarraContext()
  const [globalFilter, setGlobalFilter] = useState('')
  const [notaFiscal, setNotaFiscal] = useState(pickingCodigoBarraContext.notaFiscal || '')
  const [isSearching, setIsSearching] = useState(false)
  const [considerarPeriodo] = useState(true)

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    localDispatch.filterPickings(
      state.pickings,
      state.selectedEmpresa.map(e => e.value),
      state.selectedStatus.map(s => s.value),
      state.selectedOcorrencia.map(o => o.value),
    )
  }, [state.pickings, state.selectedEmpresa, state.selectedStatus, state.selectedOcorrencia])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.FILTERING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getPickings(state.periodo.dataInicial, state.periodo.dataFinal, selectedTp)
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deletePick(state.selectedPick)
        break

      case LOAD_MESSAGE.PREPARE_DOWNLOAD:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.changeStatusToReadyToDownload(state.selectedPick)
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        break

      case LOAD_MESSAGE.SUCCESS_DOWNLOAD:
        dispatch(showMessageBox(state.loadingMessage, null))
        localDispatch.resetState()
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      dispatch(selectedPickingChanged(state.selectedPick))
      history.push(state.pathToRedirect, { selectedPicking: state.selectedPick })
    }
  }, [state.pathToRedirect])

  useEffect(() => {
    setNotaFiscal(pickingCodigoBarraContext.notaFiscal || '')
  }, [pickingCodigoBarraContext.notaFiscal])

  const buscarPorNotaFiscal = async () => {
    if (!selectedTp) {
      dispatch(showMessageBox(null, 'Selecione um TP antes de buscar'))
      return
    }
    if (!notaFiscal.trim()) {
      dispatch(showMessageBox(null, 'Digite a Nota Fiscal para buscar'))
      return
    }
    const empresasSelecionadas = state.selectedEmpresa.map(e => e.value)
    if (empresasSelecionadas.length === 0) {
      dispatch(showMessageBox(null, 'Selecione uma empresa para buscar por Nota Fiscal'))
      return
    }
    if (empresasSelecionadas.length > 1) {
      dispatch(showMessageBox(null, 'Selecione apenas uma empresa para buscar por Nota Fiscal'))
      return
    }
    const empresaSelecionada = empresasSelecionadas[0]
    setPickingCodigoBarraContext({
      ...pickingCodigoBarraContext,
      notaFiscal: notaFiscal.trim(),
    })
    setIsSearching(true)
    try {
      let pickings
      if (considerarPeriodo) {
        pickings = await PickingHttp.getPickingsByNF(
          selectedTp,
          notaFiscal.trim(),
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          empresaSelecionada,
          'Codigo de Barra',
        )
      } else {
        pickings = await PickingHttp.getPickingsByNF(
          selectedTp,
          notaFiscal.trim(),
          undefined,
          undefined,
          empresaSelecionada,
          'Codigo de Barra',
        )
      }
      localDispatch.filterPickings(
        pickings,
        state.selectedEmpresa.map(e => e.value),
        state.selectedStatus.map(s => s.value),
        state.selectedOcorrencia.map(o => o.value),
      )
    } catch (error) {
      dispatch(showMessageBox(null, error.message || 'Erro ao buscar por nota fiscal'))
    } finally {
      setIsSearching(false)
    }
  }

  return (
    <div>
      <PageHeader>4.3 - Picking Código de Barra</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={selectedTp}
          onVoltar={history.goBack}
        >
          <>
            <div className="p-grid" style={{ marginBottom: 20 }}>
              <div className="p-col-4">
                <Periodo
                  btnEnabled={selectedTp}
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onPesquisar={localDispatch.onBtnPesquisarClick}
                />
              </div>
              <div className="p-col-1" style={{ paddingTop: 34 }}>
                <Btn
                  disabled={!selectedTp}
                  onClick={() => localDispatch.onExportarClick(state.filterdPickings)}
                >
                  Exportar
                </Btn>
              </div>
              <div className="p-col-12">
                <Fieldset legend="Filtro" toggleable collapsed={true}>
                  <div className="p-grid p-align-center">
                    <div className="p-col-3">
                      <CustomMultiSelect
                        marginTop={9}
                        filter={true}
                        optionLabel="label"
                        options={state.empresas}
                        value={state.selectedEmpresa}
                        label="Empresa"
                        onChange={value => localDispatch.onFilterChange('selectedEmpresa', value)}
                      />
                    </div>
                    <div className="p-col-3">
                      <InputText
                        label="Nota Fiscal"
                        value={notaFiscal}
                        onChange={value => {
                          setNotaFiscal(value)
                          setPickingCodigoBarraContext({
                            ...pickingCodigoBarraContext,
                            notaFiscal: value,
                          })
                        }}
                      />
                    </div>
                    <div className="p-col-3" style={{ marginTop: 32 }}>
                      <Btn isLoading={isSearching} onClick={buscarPorNotaFiscal}>
                        Buscar
                      </Btn>
                    </div>
                  </div>
                  <div className="p-grid p-align-center">
                    <div className="p-col-3">
                      <CustomMultiSelect
                        marginTop={9}
                        filter={true}
                        optionLabel="label"
                        options={state.status}
                        value={state.selectedStatus}
                        label="Status"
                        onChange={value => localDispatch.onFilterChange('selectedStatus', value)}
                      />
                    </div>
                    <div className="p-col-3">
                      <CustomMultiSelect
                        marginTop={9}
                        optionLabel="label"
                        options={OCORRENCIA_FILTER_OPTIONS}
                        value={state.selectedOcorrencia}
                        label="Ocorrência"
                        onChange={value =>
                          localDispatch.onFilterChange('selectedOcorrencia', value)
                        }
                      />
                    </div>
                  </div>
                </Fieldset>
              </div>
            </div>
            <div className="p-col-12">
              <DataTable
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                globalFilter={globalFilter}
                value={state.filterdPickings}
                emptyMessage="Não existe separação para o período selecionado"
                paginator
                rows={10}
              >
                <Column field="id" header="Código" style={tableCellCentered(80)} />
                <Column field="name" header="Picking - Descrição" />
                <Column
                  field="type"
                  header="Tipo"
                  style={tableCellCentered(180)}
                  body={pick => <PickingType type={pick.type} />}
                />
                <Column field="company_name" header="Empresa" style={tableCellCentered(200)} />
                <Column
                  field="status"
                  header="Status"
                  style={tableCellCentered(170)}
                  body={pick => {
                    const status = parsePickingStatus(pick.status)
                    const showBadgeStatus = [
                      PickingStatus.PickingConcluido.label,
                      PickingStatus.ResumoEmitido.label,
                    ].includes(pick.status)
                    const showOcorrencias = showBadgeStatus && (pick.has_falta || pick.has_sobra)
                    return (
                      <div>
                        <Badge color={status.color}>{status.label}</Badge>
                        {showOcorrencias && (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              gap: 4,
                              marginTop: 4,
                            }}
                          >
                            {pick.has_falta && (
                              <Badge color={PickingOcorrencia.ComFalta.color}>
                                {PickingOcorrencia.ComFalta.label}
                              </Badge>
                            )}
                            {pick.has_sobra && (
                              <Badge color={PickingOcorrencia.ComSobra.color}>
                                {PickingOcorrencia.ComSobra.label}
                              </Badge>
                            )}
                          </div>
                        )}
                      </div>
                    )
                  }}
                  bodyStyle={tableCellCentered()}
                />
                <Column
                  field="qteDeliveries"
                  header="Qte. Entregas"
                  style={tableCellCentered(80)}
                />
                <Column field="qteTeams" header="Qte. Equipes" style={tableCellCentered(80)} />
                <Column
                  field="qteSku"
                  header="Qte. Caixas"
                  style={tableCellCentered(80)}
                  body={picking => (picking.qteSku ? picking.qteSku.toLocaleString() : '')}
                />
                <Column
                  field="weight"
                  header="Peso"
                  style={tableCellCentered(80)}
                  body={picking => (picking.weight ? picking.weight.toLocaleString() : '')}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={pick => (
                    <ThreeDots
                      items={localDispatch.getMenuItems()}
                      onClick={item => localDispatch.onMenuItemClicked(item, pick, selectedTp)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
                {localDispatch.verifyMenuItemAllowed({ id: 15, content: '2. Apagar' }) && (
                  <Column
                    header=""
                    style={tableCellCentered(70)}
                    body={pick => (
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() =>
                          localDispatch.onMenuItemClicked('2. Apagar', pick, selectedTp)
                        }
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                )}
              </DataTable>
            </div>
          </>
        </CustomPanel>
      </div>
      <Modal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />

      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Tem certeza que deseja excluir o picking?</span>}
        onCancelar={localDispatch.onModalDeleteClose}
        onOk={() => localDispatch.onModalDeleteSave(state.modalConfirmDelete.data.pick)}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PickingCodigoBarra))
